import React from 'react';
import { Keyboard, TouchableWithoutFeedback } from 'react-native';

interface DismissKeyboardProps {
  children: React.ReactNode;
  enabled?: boolean;
}

const DismissKeyboard = ({ children, enabled }: DismissKeyboardProps) => (
  <TouchableWithoutFeedback
    onPress={() => {
      if (enabled || enabled === undefined) {
        Keyboard.dismiss();
      }
    }}
    accessible={false}>
    {children}
  </TouchableWithoutFeedback>
);

export default DismissKeyboard;
